import { Avatar, Box, Stack, Typography } from '@mui/material';
import { MenuOption, OptionsMenu } from 'framework/ui/menu';
import { ClientPortalTaskCommentReply } from '../../types';
import { getInitials } from './commentUtils';
import CommentInlineForm from './CommentInlineForm';
import { CommentActions } from './types';

type ReplyItemProps = {
  reply: ClientPortalTaskCommentReply;
  actions: CommentActions;
  isReadonly?: boolean;
};

const ReplyItem = ({ reply, actions, isReadonly = false }: ReplyItemProps) => {
  const renderReplyMenu = () => {
    if (isReadonly || reply.authorId !== actions.currentUserAlias) {
      return null;
    }

    const options: MenuOption<ClientPortalTaskCommentReply>[] = [
      {
        key: 'edit',
        label: 'Edit reply',
        onClick: () => actions.openEditReplyForm(reply),
      },
    ];

    return <OptionsMenu options={options} data={reply} />;
  };

  return (
    <Box sx={{ pl: 6, pt: 2 }}>
      <Stack direction="row" justifyContent="space-between" alignItems="flex-start" gap={2}>
        <Stack direction="row" alignItems="center" gap={1.5}>
          <Avatar sx={{ width: 28, height: 28, fontSize: 12, backgroundColor: 'primary.main', opacity: 0.5 }}>
            {getInitials(reply.authorName)}
          </Avatar>
          <Stack direction="row" alignItems="center" gap={1}>
            <Typography color="primary" variant="subtitle1">
              {reply.authorName}
            </Typography>
            <Typography color="textSecondary" variant="body2">
              {actions.getRelativeDate(reply.createdAt)}
            </Typography>
          </Stack>
        </Stack>
        {renderReplyMenu()}
      </Stack>

      {actions.activeForm?.type === 'edit-reply' && actions.activeForm.replyId === reply.id ? (
        <CommentInlineForm
          value={actions.activeForm.text}
          submitLabel="Save"
          onChange={actions.updateActiveFormText}
          onSubmit={actions.submitActiveForm}
          onCancel={actions.cancelActiveForm}
        />
      ) : (
        <Typography pl={5.5} mt={1} whiteSpace="pre-wrap">
          {reply.text}
        </Typography>
      )}
    </Box>
  );
};

export default ReplyItem;
